import MarkDown from '@efdigital/ll-addon-content/components/mark-down';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { cell, resource, use } from 'ember-resources';

import changelogUrl from '../../../CHANGELOG.md?url';
import whatsNewUrl from '../../assets/docs/WHATS_NEW.md?url';

let whatsNewPromise: Promise<string> | null = null;
let changelogPromise: Promise<string> | null = null;

function getWhatsNew() {
  if (!whatsNewPromise) {
    whatsNewPromise = fetch(whatsNewUrl).then((response) => response.text());
  }
  return whatsNewPromise;
}

function getChangelog() {
  if (!changelogPromise) {
    changelogPromise = fetch(changelogUrl).then((response) => response.text());
  }
  return changelogPromise;
}

export default class HomeWhatsNew extends Component {
  @tracked view: 'whats-new' | 'changelog' = 'whats-new';

  @use content = resource(() => {
    const content = cell<string>('');

    void getWhatsNew().then((text) => content.set(text));

    return () => content.current;
  });

  @use changelog = resource(() => {
    const changelog = cell<string>('');

    void getChangelog().then((text) => changelog.set(text));

    return () => changelog.current;
  });

  get isChangelog() {
    return this.view === 'changelog';
  }

  setView = (view: 'whats-new' | 'changelog') => {
    this.view = view;
  };

  <template>
    <div class="card border-0 bg-light rounded-4 mb-4" data-test-whats-new>
      <div class="card-header bg-transparent border-0 py-3 px-4">
        <h4 class="d-lg-flex align-items-center gap-2 mb-0">
          <iconify-icon
            inline
            icon="ph:megaphone-simple-bold"
            flip="horizontal"
          />
          <span>What&apos;s New in Admin·2</span>
          <div class="d-flex align-items-center gap-4 ms-auto">
            <button
              type="button"
              class="p-0 btn btn-link btn-sm text-dark
                {{unless
                  this.isChangelog
                  'text-decoration-underline link-offset-2'
                }}"
              {{on "click" (fn this.setView "whats-new")}}
            >
              Recent Updates
            </button>
            <button
              type="button"
              class="p-0 btn btn-link btn-sm text-dark
                {{if
                  this.isChangelog
                  'text-decoration-underline link-offset-2'
                }}"
              {{on "click" (fn this.setView "changelog")}}
            >
              Change Log
            </button>
          </div>
        </h4>
        <p class="small text-muted mb-0">Stay up to date with the latest
          features and improvements.
        </p>
      </div>
      <div
        class="card-body pt-0 px-4 pb-4 whats-new-scroll"
        role="region"
        aria-label="What's new"
      >
        <div class="whats-new-markdown">
          {{#if this.isChangelog}}
            <MarkDown
              @markdown={{this.changelog}}
              class="ll-embedded-markdown"
            />
          {{else}}
            <MarkDown @markdown={{this.content}} class="ll-embedded-markdown" />
          {{/if}}
        </div>
      </div>
    </div>
  </template>
}
